import { VideoJsPlayer } from 'video.js';
import { formatSecondsForReminder } from '../PlayerServices';
import { useEffect, useState } from 'react';
import { CustomReminder } from '../styles';

export default function RemindDuration({ player }: { player: VideoJsPlayer }) {
  const [watchedTime, setWatchedTime] = useState<number>(0);
  useEffect(() => {
    const handleTimeUpdate = () => setWatchedTime(player.currentTime());

    player.on('timeupdate', handleTimeUpdate);
    // By reference: this component is rendered twice (content and ad control bars), and the
    // playback report, ControlBarProgress, NextEpisode and SkipIntro share 'timeupdate'.
    return () => {
      player.off('timeupdate', handleTimeUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  return (
    <CustomReminder variant='body2'>
      {!!player.duration() && !!watchedTime && (
        <>
          {formatSecondsForReminder(watchedTime)} / {formatSecondsForReminder(player.duration())}
        </>
      )}
    </CustomReminder>
  );
}
